const udCorporateGifting = UD_VUE.createApp({
  data() {
    return {
      step: 0,
      accepted: false,
      company: "",
      orderInfo: {
        corporateCustomer: "",
        "full-name": "",
        email: "",
        "street-address": "",
        city: "",
        state: "",
        zip: "",
        "phone-number": "",
        items: [],
        email: "",
        approval: "pending",
      },
    };
  },
  computed: {
    totalPrice() {
      let total;
      for (const item in this.orderInfo.items) {
        total = this.orderInfo.items[item].price;
        total + item.price;
      }

      return total;
    },
    currentDiscount() {
      let currentDiscount = (100 - window.discount) / 100;
      return currentDiscount;
    },
  },
  watch: {},
  methods: {
    orderInfoEmpty() {
      var fields = [
        "corporateCustomer",
        "full-name",
        "email",
        "street-address",
        "city",
        "state",
        "zip",
        "phone-number",
      ];
      var i,
        l = fields.length;
      var fieldname;
      for (i = 0; i < l; i++) {
        fieldname = fields[i];
        if (document.forms["orderInfo"][fieldname].value === "") {
          return true;
        } else {
          return false;
        }
      }
    },
    increaseStep(event) {
      switch (this.step) {
        case 0:
          const orderFrom = document.getElementById("orderInfo");
          const formData = new FormData(orderFrom);
          for (const [key, value] of formData) {
            this.orderInfo[key] = value;
          }
          if (this.orderInfoEmpty() == true) {
            alert("Please fill out all the fields!");
          } else {
            this.step++;
          }
          break;
        case 1:
          this.postOrder();
          this.step++;
          break;
        case 2:
          // code block
          break;
        default:
        // code block
      }
    },
    productModal(handle) {
      udundi.productModal(handle, false, "", 1, (gift = false), (corporate = true));
    },
    postOrder() {
      const prodApi = "https://ce-admin-dashboard.fly.dev/api/corporate-gifts";

      const data = this.orderInfo;
      fetch(`${prodApi}/post-order`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      })
        .then((response) => response.json())
        .then((data) => {
          console.log("Success:", data);
          if (data.success != undefined) {
            this.accepted = true;
          } else {
            this.step == 0;
          }
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },
  },
  created() {
    const prodApi = "https://ce-admin-dashboard.fly.dev/api/corporate-gifts";

    fetch(`${prodApi}/customers`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((response) => response.json())
      .then((data) => {
        const companySelect = document.getElementById("corporateCustomer");
        for (var i = 0; i < data.companyNames.length; i++) {
          let c = data.companyNames[i].company;
          var option = new Option(c, c);
          companySelect.appendChild(option);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  },
  mounted() {},
}).mount("#udCorporatGifts");

document.getElementById("orderInfoSubmit").addEventListener("click", function (event) {
  event.preventDefault();
});
